import script from "./AppDownloadCta.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDownloadCta.vue?vue&type=script&setup=true&lang=js"

export default script